<template>
  <div v-if="$company.setting"
    class="tile is-parent pl-1">
    <section class="tile is-child box">
      <div class="subtitle">Company Setting</div>
      <div class="field">
        <label class="label">Item Description AutoComplete</label>
        <div class="control">
          <div class="pretty p-switch p-fill">
            <input type="checkbox"
              @change="onChangeAutoCompleteSwitch"
              :checked="$company.setting.itemAutoCompleteEnabled">
            <div class="state p-primary">
              <label>{{ $company.setting.itemAutoCompleteEnabled ? "On" : "Off" }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Parts Control Enabled</label>
        <div class="control">
          <div class="pretty p-switch p-fill">
            <input type="checkbox"
              @change="onChangePartsControlSwitch($event, 'PartsControlEnabled')"
              :checked="$company.setting.partsControlEnabled">
            <div class="state p-primary">
              <label>{{ $company.setting.partsControlEnabled ? "On" : "Off" }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Quote AutoSave Enabled</label>
        <div class="control">
          <div class="pretty p-switch p-fill">
            <input type="checkbox"
              @change="onChangeAutoSaveSwitch"
              :checked="$company.setting.quoteAutoSaveEnabled">
            <div class="state p-primary">
              <label>{{ $company.setting.quoteAutoSaveEnabled ? "On" : "Off" }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">AutoSave Manual Save Button Enabled</label>
        <div class="control">
          <div class="pretty p-switch p-fill">
            <input type="checkbox"
              :disabled="!$company.setting.quoteAutoSaveEnabled"
              @change="onChangePartsControlSwitch($event, 'AutoSaveManualSaveEnabled')"
              :checked="manualSaveEnabled">
            <div class="state p-primary">
              <label>{{ manualSaveEnabled ? "On" : "Off" }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Quote Presence Enabled</label>
        <div class="control">
          <div class="pretty p-switch p-fill">
            <input type="checkbox"
              @change="onChangePartsControlSwitch($event, 'QuotePresenceEnabled')"
              :checked="$company.setting.quotePresenceEnabled">
            <div class="state p-primary">
              <label>{{ $company.setting.quotePresenceEnabled ? "On" : "Off" }}</label>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce'
// import globalSearchService from '../../../components/GobalSearch/GlobalSearchService'
export default {
  name: 'CompanySetting',
  components: {},
  mixins: [],
  props: {},
  data: () => {
    return {}
  },
  computed: {
    // Manual save is only meaningful when autosave is on; treat it as off whenever
    // autosave is disabled, regardless of the stored value.
    manualSaveEnabled() {
      return this.$company.setting.quoteAutoSaveEnabled && this.$company.setting.autoSaveManualSaveEnabled
    }
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    // async indexQuotesForAlgolia() {
    //   try {
    //     await globalSearchService.indexQuotes()
    //     this.$toast.success('Quotes indexed successfully for Algolia search.')
    //   } catch (error) {
    //     console.error('Error indexing quotes for Algolia:', error)
    //     // this.$toast.error('Failed to index quotes for Algolia search.')
    //   }

    // },
    onChangeAutoCompleteSwitch: _debounce(function (event) {
      this.setItemAutoCompleteEnabled(event.target.checked)
    }, 300),
    onChangePartsControlSwitch: _debounce(function (event, settingName) {
      this.alterCompanySettings({
        settingName,
        value: event.target.checked
      })
    }, 300),
    onChangeAutoSaveSwitch: _debounce(function (event) {
      const enabled = event.target.checked
      this.alterCompanySettings({
        settingName: 'QuoteAutoSaveEnabled',
        value: enabled
      })
      // Turning autosave off also clears the dependent manual-save setting so it
      // can't be left stranded as "on" while autosave is disabled.
      if (!enabled && this.$company.setting.autoSaveManualSaveEnabled) {
        this.alterCompanySettings({
          settingName: 'AutoSaveManualSaveEnabled',
          value: false
        })
      }
    }, 300)
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  }
}
</script>

<style lang="scss" scoped>
</style>
